import { Outlet } from 'react-router'
import { SiteFooter } from '#app/components/site-footer.tsx'

/**
 * Pre-auth shell for the public/marketing pages. The footer itself
 * (components/site-footer.tsx) is shared with the other public surfaces.
 */
export default function MarketingLayout() {
	return (
		<div className="flex min-h-screen flex-col">
			<div className="flex flex-1 flex-col">
				<Outlet />
			</div>
			<SiteFooter />
		</div>
	)
}
